import { render, staticRenderFns } from "./heading.vue?vue&type=template&id=f1b21a9c&scoped=true"
import script from "./heading.vue?vue&type=script&lang=js"
export * from "./heading.vue?vue&type=script&lang=js"
import style0 from "./heading.vue?vue&type=style&index=0&id=f1b21a9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b21a9c",
  null
  
)

export default component.exports